var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Preloader fade-out on load
if (document.getElementById("preloader")) {
  window.addEventListener("load", function () {
    var preloader = document.getElementById("preloader");
    if (!preloader) return;
    setTimeout(function () {
      preloader.style.transition = "opacity 1s ease";
      preloader.style.opacity = "0";
      preloader.addEventListener("transitionend", function handler() {
        preloader.style.display = "none";
        document.body.classList.remove("preloader-overflow");
        preloader.removeEventListener("transitionend", handler);
      });
    }, 1000);
  });
}

// Sticky bar scroll handler
window.addEventListener("scroll", function () {
  var stickyBars = document.querySelectorAll(".sticky-bar");
  if (!stickyBars.length) return;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var winWidth = window.innerWidth;
  stickyBars.forEach(function (el) {
    if (winWidth > 1024) {
      el.style.display = scrollTop >= 500 ? "flex" : "none";
    } else {
      el.style.display = scrollTop >= 900 ? "flex" : "none";
    }
  });
});

// Recently viewed toggle
document.addEventListener("DOMContentLoaded", function () {
  var recentlyBtn = document.getElementById("recently");
  var recentlyPanel = document.getElementById("recently-viewed-products");
  if (recentlyBtn && recentlyPanel) {
    recentlyPanel.style.overflow = "hidden";
    recentlyPanel.style.transition = "max-height 0.5s ease";
    recentlyPanel.style.maxHeight = recentlyPanel.scrollHeight + "px";
    recentlyBtn.addEventListener("click", function () {
      if (!recentlyPanel.style.maxHeight || recentlyPanel.style.maxHeight === "0px") {
        recentlyPanel.style.maxHeight = recentlyPanel.scrollHeight + "px";
      } else {
        recentlyPanel.style.maxHeight = "0";
      }
    });
  }
});

var afterInfiniteLoaded = function afterInfiniteLoaded() {
  document.querySelectorAll(".loading-image").forEach(function (el) {
    el.classList.remove("loading-image");
    el.classList.add("loaded-image");
  });
};
var AjaxMethod = document.querySelector(".pagination-method-loadmore_btn") ? "click" : "scroll";
if (document.querySelector(".collection #AjaxinatePagination")) {
  var endlessScroll = new Ajaxinate({
    container: ".AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: AjaxMethod,
    offset: 0,
    callback: afterInfiniteLoaded,
  });
}

InitCustomFunctions();
function InitCustomFunctions() {
  var toggleFilter = document.querySelector(".toggleFilter");
  if (toggleFilter) {
    var sidebar = document.querySelector(".facets-vertical");
    var closeDiv = document.querySelector(".close-sidebar");

    toggleFilter.addEventListener("click", function () {
      toggleFilter.classList.toggle("active");
      if (sidebar) sidebar.classList.toggle("open");
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("filter-clicked");
    });

    if (closeDiv) {
      closeDiv.addEventListener("click", function () {
        toggleFilter.classList.remove("active");
        if (sidebar) sidebar.classList.remove("open");
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("filter-clicked");
      });
    }
  }

  // Product page color variant — thumbnail list filter
  if (document.querySelector(".show-grouped__variant")) {
    document.querySelectorAll('input[type="radio"][name="Color"]').forEach(function (radio) {
      radio.addEventListener("click", function () {
        var cvariant = this.value;
        document.querySelectorAll('input[type="radio"][name="Color"]').forEach(function (r) {
          var next = r.nextElementSibling;
          if (next && next.classList.contains("swatch-element")) {
            next.classList.remove("clicked");
          }
        });
        var myNext = this.nextElementSibling;
        if (myNext && myNext.classList.contains("swatch-element")) {
          myNext.classList.add("clicked");
        }
        document.querySelectorAll(".thumbnail-list__item").forEach(function (item) {
          var img = item.querySelector("img");
          var variant_val = img ? img.getAttribute("alt") : null;
          if (cvariant === variant_val) {
            item.classList.add("show");
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
            item.classList.remove("show");
          }
        });
      });
    });
  }

  // Item swatch trigger — color-values
  document.addEventListener("click", function (e) {
    var colorA = e.target.closest(".color-values a");
    if (colorA) {
      document.querySelectorAll(".color-values a").forEach(function (a) { a.classList.remove("active"); });
      if (!colorA.classList.contains("active")) {
        colorA.classList.add("active");
      }
    }
  });

  // Item swatch trigger — size-values
  document.addEventListener("click", function (e) {
    var sizeA = e.target.closest(".size-values a");
    if (sizeA) {
      document.querySelectorAll(".size-values a").forEach(function (a) { a.classList.remove("active"); });
      var sizeValues = sizeA.closest(".products");
      if (sizeValues) {
        sizeValues.querySelectorAll(".variant-option-size .size-values").forEach(function (sv) { sv.classList.remove("active"); });
      }
      if (!sizeA.classList.contains("active")) {
        sizeA.classList.add("active");
      }
    }
  });

  // color-values-plus show more
  document.body.addEventListener("click", function (e) {
    var plusA = e.target.closest(".color-values-plus a");
    if (plusA) {
      e.preventDefault();
      var varOptColor = plusA.closest(".variant-option-color");
      if (varOptColor) {
        var showOnClick = varOptColor.querySelector(".show-on-click");
        if (showOnClick) showOnClick.style.display = "flex";
      }
      var colorValuePlus = plusA.closest(".color-values-plus");
      if (colorValuePlus) colorValuePlus.style.display = "none";
    }
  });

  // swatch span click — card image + variant push
  document.body.addEventListener("click", function (e) {
    var span = e.target;
    if (span.tagName !== "SPAN" || !span.closest(".swatch")) return;
    var swatch = span.closest(".swatch");
    var cardWrapper = span.closest(".card-wrapper");
    if (cardWrapper) {
      var motionReduce = cardWrapper.querySelector(".card__inner .motion-reduce");
      if (motionReduce) {
        motionReduce.setAttribute("srcset", span.getAttribute("data-image") || "");
      }
    }

    if (swatch && swatch.classList.contains("color")) {
      var variant = span.getAttribute("data-id");
      var productGrid = span.closest(".product-grid");
      if (productGrid) {
        var variantPush = productGrid.querySelector(".variant-push");
        if (variantPush) variantPush.value = variant;

        var swatch_item = span.getAttribute("data-variant-item");

        productGrid.querySelectorAll(".variant-option-size .size-values").forEach(function (sv) {
          sv.classList.remove("active");
        });

        productGrid.querySelectorAll(".variant-option-size .swatch").forEach(function (swatchEl) {
          var innerSpan = swatchEl.querySelector("span");
          if (!innerSpan) return;
          var variantTitle = innerSpan.getAttribute("data-variant-title") || "";
          var swatch_size_vars = variantTitle.split("/").map(function (n) {
            return n.trim().toLowerCase().replace(/ /g, "-");
          });
          if (swatch_size_vars.includes(swatch_item)) {
            var sizeValues = swatchEl.closest(".size-values");
            if (sizeValues) sizeValues.classList.toggle("active");
          }
        });
      }
    }

    if (swatch && swatch.classList.contains("size")) {
      var variant2 = span.getAttribute("data-id");
      var productGrid2 = span.closest(".product-grid");
      if (productGrid2) {
        var variantPush2 = productGrid2.querySelector(".variant-push");
        if (variantPush2) variantPush2.value = variant2;
      }
    }
  });

  // Product grid column selector
  document.querySelectorAll(".custom-product-grid li").forEach(function (li) {
    li.addEventListener("click", function () {
      var classNames =
        "list-view-filter grid--2-col-desktop grid--3-col-desktop grid--4-col-desktop grid--5-col-desktop grid--6-col-desktop";
      var getCols = this.getAttribute("data-cols");
      document.querySelectorAll(".custom-product-grid li").forEach(function (el) { el.classList.remove("active"); });
      this.classList.add("active");
      var productGrid = document.querySelector("ul#product-grid");
      if (productGrid) {
        classNames.split(" ").forEach(function (c) { productGrid.classList.remove(c); });
        if (getCols) productGrid.classList.add(getCols);
      }
    });
  });

  if (document.querySelector(".filter-buttons")) {
    var viewExists = document.querySelector(".grid-view-button");
    if (viewExists && viewExists.classList.contains("layout-mode")) {
      var listViewButton = document.querySelector(".list-view-button");
      var gridViewButton = document.querySelector(".grid-view-button");
      var list = document.querySelector("ul.view-mode");
      var gridviewlist = document.querySelector(".custom-product-grid");

      if (listViewButton) {
        listViewButton.onclick = function () {
          listViewButton.classList.add("active");
          if (gridViewButton) gridViewButton.classList.remove("active");
          if (list) { list.classList.remove("grid-view-filter"); list.classList.add("list-view-filter"); }
          if (gridviewlist) gridviewlist.classList.add("hidden");
        };
      }

      if (gridViewButton) {
        gridViewButton.onclick = function () {
          if (listViewButton) listViewButton.classList.remove("active");
          gridViewButton.classList.add("active");
          if (list) { list.classList.remove("list-view-filter"); list.classList.add("grid-view-filter"); }
          if (gridviewlist) gridviewlist.classList.remove("hidden");
        };
      }
    }
  }

  if (document.getElementById("swiper-sidebar-carousel")) {
    var swiper = new Swiper("#swiper-sidebar-carousel", {
      navigation: {
        nextEl: "#swiper-sidebar-next",
        prevEl: "#swiper-sidebar-prev",
      },
    });
  }

  setTimeout(function () {
    document.querySelectorAll(".loading-image").forEach(function (el) {
      el.classList.remove("loading-image");
      el.classList.add("loaded-image");
    });
  }, 2000);
}

// FBT custom select box
document.body.addEventListener("click", function (e) {
  // Toggle dropdown items on .init click
  var initLi = e.target.closest("ul.custom-select li.init");
  if (initLi) {
    var ul = initLi.closest("ul.custom-select");
    if (ul) {
      ul.querySelectorAll("li:not(.init)").forEach(function (li) {
        li.style.display = li.style.display === "none" ? "" : "none";
      });
    }
    return;
  }

  // Handle non-init li click
  var listItem = e.target.closest("ul.custom-select li:not(.init)");
  if (!listItem) return;

  var selectUl = listItem.closest("ul.custom-select");
  var selectedVal = listItem.getAttribute("data-option-value");

  // Update select option value
  var metaEl = listItem.closest(".fbt-product__meta");
  if (metaEl) {
    metaEl.querySelectorAll(".selectVariant option").forEach(function (opt) {
      opt.removeAttribute("selected");
    });
    var targetOpt = metaEl.querySelector(".selectVariant option[value='" + selectedVal + "']");
    if (targetOpt) {
      targetOpt.setAttribute("selected", "selected");
      targetOpt.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Update visual state
  if (selectUl) {
    selectUl.querySelectorAll("li:not(.init)").forEach(function (li) {
      li.classList.remove("selected");
    });
    listItem.classList.add("selected");
    var initEl = selectUl.querySelector(".init");
    if (initEl) {
      initEl.innerHTML = listItem.innerHTML;
      initEl.classList.remove("li-unselected");
    }
    selectUl.querySelectorAll("li:not(.init)").forEach(function (li) {
      li.style.display = "none";
    });
  }

  // Toggle FBT button disabled state
  var anyUnselected = document.querySelectorAll("ul.custom-select li.init.li-unselected").length > 0;
  var addFbt = document.getElementById("add-frequently-bought");
  if (addFbt) addFbt.disabled = anyUnselected;
});

loadedBg();
function loadedBg() {
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll(".loading-image").forEach(function (el) {
        el.classList.remove("loading-image");
        el.classList.add("loaded-image");
      });
    }, 3000);
  });
}

// Search overlay open/close
var dT_TopStickySearchBtn = document.getElementById("dT_TopStickySearchBtn");
if (dT_TopStickySearchBtn) {
  dT_TopStickySearchBtn.addEventListener("click", function (ev) {
    ev.preventDefault();
    var sticky = document.getElementById("dT_top-sticky");
    if (sticky) {
      sticky.classList.add("search-show");
      var searchModal = sticky.querySelector(".search-modal");
      if (searchModal) searchModal.style.opacity = "1";
    }
    document.body.classList.add("search-overlay-open");
  });
}

document.querySelectorAll(".dT_TopStickySearchCloseBtn").forEach(function (btn) {
  btn.addEventListener("click", function (ev) {
    ev.preventDefault();
    var sticky = document.getElementById("dT_top-sticky");
    if (sticky) {
      sticky.classList.remove("search-show");
      var searchModal = sticky.querySelector(".search-modal");
      if (searchModal) searchModal.style.opacity = "0";
    }
    document.body.classList.remove("search-overlay-open");
  });
});

setTimeout(function () {
  document.querySelectorAll("#AccessibleNav .sub-menu-block").forEach(function (el) {
    el.style.display = "";
  });
}, 1000);


// Footer accordion toggles
document.querySelectorAll(".footer-links, .footer_address").forEach(function (el) {
  el.addEventListener("click", function () {
    this.classList.toggle("open");
  });
});
